export const APP_CONFIG = {
  MAX_LOGIN_ATTEMPTS: 5,
  LOGIN_TIMEOUT: 15 * 60 * 1000, // 15 minutes
  API_ENDPOINTS: {
    BASE_URL: 'https://services.shopiweb.fr/api',
    LICENSES: '/licenses',
    USERS: '/users'
  },
  STORAGE: {
    PROFILE_PHOTOS: 'profile-photos',
    MAX_FILE_SIZE: 5 * 1024 * 1024 // 5MB
  }
};